import { AgropilotFeature, AgropilotRole, AgropilotRoleHasFeatureAccess } from '@agroone/entities'
import { Injectable, inject } from '@angular/core'
import { SharedUserService } from './shared-user.service'

@Injectable({
  providedIn: 'root',
})
export class AgropilotPermissionManagerService {
  private userService = inject(SharedUserService)

  hasPermission(
    actualRole: AgropilotRole | null | undefined,
    feature: AgropilotFeature,
    access: 'read' | 'write',
  ): boolean {
    // A user without role has no entry in the permissions mapping
    return !!actualRole && AgropilotRoleHasFeatureAccess(actualRole, feature, access)
  }

  public isGrantedAgropilotAccess(): boolean {
    return !!this.userService.currentUser?.agropilotRole
  }
}
